import React, { useRef, useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import db from './Firebase';

const Invoice = () => {
    const invoiceRef = useRef();
    const { id: txid } = useParams();
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [searchParams] = useSearchParams();
    const buyer_name = searchParams.get("name");

    useEffect(() => {
        if (!txid) return;

        db.collection('nv_transaction_history')
            .where('txid', '==', txid)
            .get()
            .then(snapshot => {
                if (!snapshot.empty) {
                    const items = snapshot.docs.map(doc => doc.data());
                    setInvoiceItems(items);
                } else {
                    console.log('No matching transaction found.');
                }
            })
            .catch(err => console.error('Error fetching invoice data:', err));
    }, [txid]);

    const downloadPDF = () => {
        html2canvas(invoiceRef.current, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#fff'
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, imgHeight);
            pdf.save(`Invoice_${invoiceItems[0]?.txid}.pdf`);
        });
    };

    // if (!invoiceData[0]) return <p>Loading invoice...</p>;

    // const totalPrice = invoiceItems.reduce((acc, item) => acc + Number(item.price.replace(/[^0-9]/g, '')), 0);
    // const totalDiscount = invoiceItems.reduce((acc, item) => acc + Number(item.discount), 0);
    // const grandTotal = totalPrice - totalDiscount;

    const totalDiscount = invoiceItems.reduce((acc, item) => acc + Number(item.discount), 0);

    const grandTotal = invoiceItems.reduce((acc, item) => {
        const price = Number(item.price.replace(/[^0-9]/g, ''));
        return acc + price;
    }, 0);

    const totalPrice = grandTotal + totalDiscount;

    const tableHeaderCell = {
        padding: '12px 10px',
        fontWeight: 'bold',
        borderBottom: '1px solid #ddd',
        textAlign: 'left'
    };

    const tableCell = {
        padding: '10px',
        borderBottom: '1px solid #eee'
    };


    return (
        <>

            <div>


                <div ref={invoiceRef} className="invoice-box" style={{ padding: '20px', maxWidth: '800px', fontFamily: 'Arial' }}>
                    {/* Header Logos */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px',
                        borderBottom: '1px solid #ccc',
                        paddingBottom: '20px'
                    }}>
                        <img src="/yl.png" alt="Youvati Logo" style={{ height: '40px' }} />
                        {/* <img src="/el.png" alt="Empower Logo" style={{ height: '40px' }} /> */}
                    </div>
                    <p style={{ fontSize: "2rem", color: "#7872F8", fontWeight: "bold" }}>Invoice</p>


                    <h2></h2>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            {/* <h4 style={{ color: "#7872F8", fontWeight: "600" }}>Buyer Details</h4> */}
                            <p style={{ color: "#7872F8", fontWeight: "600" }}>{buyer_name}</p>
                            <p>Phone : {invoiceItems[0]?.phone}</p>
                            <p><strong>Date:</strong> {invoiceItems[0]?.createdAt?.toDate().toLocaleDateString()}</p>
                        </div>
                        <div>
                            <p><strong>Invoice Number:</strong> {invoiceItems[0]?.txid}</p>

                            {/* <p>Payment ID: {invoiceItems[0]?.txid}</p> */}
                            <p><strong>Mode : UPI</strong></p>
                        </div>
                    </div>



                    {/* Summary Table */}

                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginTop: '1.5rem',
                        fontSize: '14px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                    }}>
                        <thead style={{ backgroundColor: '#F3F4F6', color: '#374151' }}>
                            <tr>
                                <th style={tableHeaderCell}>Item</th>
                                <th style={tableHeaderCell}>Price</th>
                                <th style={tableHeaderCell}>Discount</th>
                                <th style={tableHeaderCell}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceItems.map((item, idx) => {
                                const paidAmount = Number(item.price.replace(/[^0-9]/g, ''));
                                const discount = Number(item.discount);
                                const originalPrice = paidAmount + discount;

                                return (
                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#FFFFFF' : '#FAFAFA' }}>
                                        <td style={tableCell}>{item.subtitle}</td>
                                        <td style={tableCell}>₹ {originalPrice}</td>
                                        <td style={tableCell}>₹ {discount}</td>
                                        <td style={tableCell}>₹ {paidAmount}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px' }}>
                        <table style={{ fontSize: '14px', lineHeight: '1.8', minWidth: '260px' }}>
                            <tbody>
                                <tr>
                                    <td >SUBTOTAL:</td>
                                    <td style={{ textAlign: 'right' }}>₹ {totalPrice}</td>
                                </tr>
                                <tr>
                                    <td >DISCOUNT:</td>
                                    <td style={{ textAlign: 'right' }}>-₹ {totalDiscount}</td>
                                </tr>

                                <tr>
                                    <td style={{ fontWeight: 'bold', fontSize: '16px', paddingTop: '10px' }}>FINAL AMOUNT PAID:</td>
                                    <td style={{ textAlign: 'right', color: "#7872F8", fontSize: '16px', fontWeight: 'bold', paddingTop: '10px' }}>
                                        ₹ {grandTotal}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Contact Message */}
                    <p style={{ textAlign: 'center', marginTop: '40px', fontSize: '14px', color: '#555' }}>
                        If you have any questions regarding your order, feel free to contact Youvati at{' '}
                        <a href="mailto:support@youvati.com" style={{ color: '#007BFF', textDecoration: 'none' }}>
                            support@youvati.com
                        </a>
                    </p>

                </div>

                {/* <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button onClick={downloadPDF} style={{ padding: '10px 20px' }}>
                        Download Invoice
                    </button>
                </div> */}
                <div
                    className="no-print"
                    style={{
                        display: 'flex',
                        justifyContent: 'center', // 💡 This is the fix!
                        textAlign: 'center',
                        gap: '12px',
                        marginBottom: '20px',
                        marginTop: '20px'
                    }}
                >
                    <button
                        onClick={downloadPDF}
                        style={{
                            backgroundColor: '#7872F8',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <i className="fa fa-download" aria-hidden="true"></i> Download
                    </button>

                    <button
                        onClick={() => window.print()}
                        style={{
                            backgroundColor: '#4B5563',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <i className="fa fa-print" aria-hidden="true"></i> Print
                    </button>
                </div>
            </div>
        </>
    );
};

export default Invoice;



// // src/components/Invoice.js
// import React, { useRef } from 'react';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import invoiceData from './invoiceData';

// const Invoice = () => {
//     const invoiceRef = useRef();
//     const downloadPDF = () => {
//         html2canvas(invoiceRef.current, {
//             scale: 2,
//             useCORS: true, // allow local images to render if needed
//             backgroundColor: '#fff'
//         }).then((canvas) => {
//             const imgData = canvas.toDataURL('image/png');
//             const pdf = new jsPDF('p', 'mm', 'a4');

//             const pdfWidth = pdf.internal.pageSize.getWidth();   // 210mm for A4
//             const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm for A4

//             const imgProps = pdf.getImageProperties(imgData);
//             const imgWidth = pdfWidth;
//             const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

//             // If the content height is taller than one page, we'll add pages later (future extension)
//             pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
//             pdf.save(`Invoice_${invoiceItems[0]?.invoiceNumber}.pdf`);
//         });
//     };


//     const tableHeaderCell = {
//         padding: '12px 10px',
//         fontWeight: 'bold',
//         borderBottom: '1px solid #ddd',
//         textAlign: 'left'
//     };

//     const tableCell = {
//         padding: '10px',
//         borderBottom: '1px solid #eee'
//     };



//     const total = invoiceItems[0]?.items.reduce((acc, item) => acc + (item.price - item.discount), 0);

//     return (
//         <>
//             <div>


//                 <div ref={invoiceRef} className="invoice-box" style={{ padding: '20px', fontFamily: 'Arial' }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         marginBottom: '50px',
//                         borderBottom: '1px solid #ccc',
//                         paddingBottom: '20px'
//                     }}>
//                         <img src="/yl.png" alt="Youvati Logo" style={{ height: '40px' }} />
//                         <img src="/el.png" alt="Empower Logo" style={{ height: '40px' }} />
//                     </div>

//                     <p style={{ fontSize: "2rem", color: "#7872F8", fontWeight: "bold" }}>Invoice</p>
//                     <h2></h2>
//                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                         <div>
//                             {/* <h4 style={{ color: "#7872F8", fontWeight: "600" }}>Buyer Details</h4> */}
//                             <p style={{ color: "#7872F8", fontWeight: "600" }}>{invoiceItems[0]?.buyer.name}</p>
//                             <p>Phone : {invoiceItems[0]?.buyer.phone}</p>
//                             <p><strong>Date:</strong> {invoiceItems[0]?.date}</p>
//                         </div>
//                         <div>
//                             <p><strong>Invoice Number:</strong> #{invoiceItems[0]?.invoiceNumber}</p>

//                             <p>Payment ID: {invoiceItems[0]?.payment.id}</p>
//                             <p><strong>Mode : {invoiceItems[0]?.payment.method}</strong></p>
//                         </div>
//                     </div>



//                     <table style={{
//                         width: '100%',
//                         borderCollapse: 'collapse',
//                         marginTop: '1.5rem',
//                         fontSize: '14px',
//                         borderRadius: '8px',
//                         overflow: 'hidden',
//                         boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
//                     }}>
//                         <thead style={{ backgroundColor: '#F3F4F6', color: '#374151' }}>
//                             <tr>
//                                 <th style={tableHeaderCell}>Item</th>
//                                 <th style={tableHeaderCell}>Price</th>
//                                 <th style={tableHeaderCell}>Qty</th>
//                                 <th style={tableHeaderCell}>Discount</th>
//                                 <th style={tableHeaderCell}>Total</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {invoiceItems[0]?.items.map((item, idx) => (
//                                 <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#FFFFFF' : '#FAFAFA' }}>
//                                     <td style={tableCell}>{item.name}</td>
//                                     <td style={tableCell}>₹ {item.price}</td>
//                                     <td style={tableCell}>{item.qty}</td>
//                                     <td style={tableCell}>₹ {item.discount}</td>
//                                     <td style={tableCell}>₹ {item.price - item.discount}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>

//                     <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px' }}>
//                         <table style={{ fontSize: '14px', lineHeight: '1.8', minWidth: '260px' }}>
//                             <tbody>
//                                 <tr>
//                                     <td >SUBTOTAL:</td>
//                                     <td style={{ textAlign: 'right' }}>₹ {invoiceItems[0]?.items[0].price}</td>
//                                 </tr>
//                                 <tr>
//                                     <td >SEASONAL DISCOUNT:</td>
//                                     <td style={{ textAlign: 'right' }}>-₹ {invoiceItems[0]?.seasonalDiscount}</td>
//                                 </tr>
//                                 <tr>
//                                     <td >GLOW DISCOUNT:</td>
//                                     <td style={{ textAlign: 'right' }}>-₹ {invoiceItems[0]?.glowDiscount}</td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{ fontWeight: 'bold', fontSize: '16px', paddingTop: '10px' }}>FINAL AMOUNT PAID:</td>
//                                     <td style={{ textAlign: 'right', color: "#7872F8", fontSize: '16px', fontWeight: 'bold', paddingTop: '10px' }}>
//                                         ₹ {total}
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>



//                     <p style={{
//                         textAlign: 'center',
//                         marginTop: '40px',
//                         fontSize: '14px',
//                         color: '#555'
//                     }}>
//                         If you have any questions regarding your order, feel free to contact Youvati at{' '}
//                         <a href="mailto:support@youvati.com" style={{ color: '#007BFF', textDecoration: 'none' }}>
//                             support@youvati.com
//                         </a>
//                     </p>



//                 </div>

//                 <button onClick={downloadPDF} style={{ marginTop: '20px', padding: '10px 20px' }}>
//                     Download Invoice
//                 </button>


//             </div>
//         </>
//     );
// };

// export default Invoice;